<template>
  <div>
    <b-modal id="modal-rejeitar"
             centered
             hide-footer
             hide-header
             @hidden="limparJustificativa">
      <p style="font-size: 1.1rem;">
        Qual o motivo da rejeição de pedido?
      </p>
        
      <textarea
        id="justificativa"
        v-model="justificativa"
        class="form-control mb-3"
        rows="4"
        style="width: 100%; max-width: 500px;"
        placeholder="Digite sua justificativa aqui..." />

      <div class="text-right">
        <b-button class="btn-cancel-custom"
                  @click="$bvModal.hide('modal-rejeitar')">
          Cancelar
        </b-button>
        <b-button variant="secondary"
                  class="ml-2"
                  @click="$emit('confirmar-rejeicao', justificativa)">
          Confirmar
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
  export default {
    name: 'ModalRejeitarPedido',
    data () {
      return {
        justificativa: ''
      }
    },
    methods: {
      limparJustificativa () {
        this.justificativa = ''
      }
    }
  }
</script>

<style scoped lang="scss">
$base-color: #c6c6c6;
$hover-color: #bcbcbc;
$text-color: #000;

.btn-cancel-custom {
  background-color: $base-color;
  color: $text-color;
  border: 1px solid $base-color;

  &:hover {
    background-color: $hover-color;
    color: $text-color;
    border: 1px solid $hover-color;
  }
}
</style>
